import type { User } from '@wix/ambassador-identity-account-v2-account/types';

export type UserSlice = {
  user: User | null;
  isWixStudioUser: boolean;
  isWixEmployee: boolean;
  isBroadridgeUser: boolean;
  loggedInAccountId?: string | null;
  hasActiveLiveChatSession: boolean;
};

export const getUserInitialState = (): UserSlice => ({
  user: null,
  isWixStudioUser: false,
  isWixEmployee: false,
  isBroadridgeUser: false,
  loggedInAccountId: null,
  hasActiveLiveChatSession: false,
});
